<div class="header-accent"></div>
<div class="headerbar-container">
    <div class="w-100 h-100 header mb-3 text-center d-flex justify-content-center align-items-center">{{APP_TITLE}}</div>
</div>

<div class="footer d-flex justify-content-center align-items-center">
    <img src="assets/dxc_logo.svg" alt="App Logo" height="25">
</div>

<login-ui-container [showLoginBanner]="showLoginBanner">
    @if (showLoginBanner()) {
        <p class="login-text fw-5 text-center oxanium-medium">
            @switch (current_phase) {
                @case ("LOGIN_WINDOW"){
                    <div class="mb-5 login-text">
                        {{LOGIN}}
                    </div>
                }
                @case ("CHANGE_PASSWORD"){
                    <div class="select-database-text mb-5">
                        {{CHANGE_PASSWORD}}
                    </div>
                }
                @case ("SELECT_DATABASE"){
                    <div class="select-database-text mb-5">
                        {{SELECT_DATABASE}}
                    </div>
                }
            }
        </p>
    }
    @if(!isLoading){

        @switch (current_phase) {
            @case ("LOGIN_WINDOW"){
                <form [formGroup]="submitForm" (ngSubmit)="login()">
                    <div class="row">
                        <div class="form-group col-12">
                            <mat-form-field appearance="fill" class="col-12">
                                <input matInput formControlName="userId" placeholder="Email">
                                @if (submitForm.controls['userId'].hasError(('required'))) {
                                <mat-error>You Must Fill this field</mat-error>
                                }
                                @if (submitForm.controls['userId'].hasError(('email'))) {
                                <mat-error>Field must be an email</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="form-group col-12">
                            <mat-form-field appearance="fill" class="col-12">
                                <input matInput [type]="hide() ? 'password' : 'text'" formControlName="password"
                                    placeholder="Password">
                                <button mat-icon-button matSuffix type="button" (click)="onHide($event)"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide()">
                                    <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>
                                @if (submitForm.controls['password'].hasError(('required'))) {
                                <mat-error>You Must Fill this field</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="d-flex justify-content-end mb-4">
                            <a href="#" class="forgot-password-link"
                                (click)="$event.preventDefault(); forgotPassword()">
                                <mat-icon>lock</mat-icon>
                                Forgot your password?
                            </a>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center">
                        <button mat-button space-button type="submit">{{LOGIN}}</button>
                    </div>
                </form>
            }
            @case ("CHANGE_PASSWORD"){
                <form [formGroup]="changePassword" (ngSubmit)="onChangePassword()">
                    <div class="row">
                        <div class="form-group col-12">
                            <mat-form-field appearance="fill" class="col-12">
                                <input matInput [type]="hide() ? 'password' : 'text'" formControlName="password"
                                    [placeholder]="NEW_PASSWORD">
                                <button mat-icon-button matSuffix type="button" (click)="onHide($event)"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide()">
                                    <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>
                                @if (submitForm.controls['password'].hasError(('required'))) {
                                <mat-error>You Must Fill this field</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center">
                        <button mat-button space-button type="submit">{{CONTINUE}}</button>
                    </div>
                </form>
            }
            @case ("SELECT_DATABASE"){
                <change-database [callback]="connectToDatabase" [onCancel]="logout" [cancelText]="CANCEL_AND_LOGOUT"></change-database>
            }
            @case ("CONNECTION_FAILED"){
                <div class="d-flex justify-content-center align-items-center">
                    <div class="d-flex flex-column">
                        <div class="mt-2 d-flex justify-content-center align-items-center">
                            <mat-icon class="mb-2 notify-icon fail">task_alt</mat-icon>
                        </div>
                        <span class="fail-text text-center">{{CONNECTION_NOT_WORKING}}</span>
                        <span class="text-list mb-3 text-center">{{failDatabase}}</span>
                        <div class="d-flex justify-content-between align-items-center">
                            <button mat-button type="button" (click)="logout()" class="me-3 login-cancel__button">{{CANCEL_AND_LOGOUT}}</button>
                            <button mat-button space-button (click)="onConnectionFailed()">{{TRY_AGAIN}}</button>
                        </div>
                    </div>
                </div>
            }
            @case ("CONNECTION_SUCESS"){
                <div class="d-flex justify-content-center align-items-center">
                    <div class="d-flex flex-column">
                        <div class="mt-2 d-flex justify-content-center align-items-center">
                            <mat-icon class="notify-icon">task_alt</mat-icon>
                        </div>
                        <span class="mb-2 sucess-text text-center">{{CONNECTION_SUCESSFUL}}</span>
                        <span class="text-list mb-3 text-center">{{sucessDatabase}}</span>
                        <div class="d-flex justify-content-between align-items-center">
                            <button mat-button type="button" (click)="logout()" class="me-3 login-cancel__button">{{CANCEL_AND_LOGOUT}}</button>
                            <button mat-button space-button (click)="onConnectionSuccess()">{{CONTINUE}}</button>
                        </div>
                    </div>
                </div>
            }
        }

    }@else{
        <div class="d-flex justify-content-center align-items-center login-loading">
            <mat-progress-spinner class="custom-spinner" mode="indeterminate"> </mat-progress-spinner>
        </div>
    }
</login-ui-container>
